<app-model-site-header
  [label]="'Choose company'"
  [backButton]="buttonAppears"
></app-model-site-header>

<app-company-selection-list
  [endpoints]="endpoints"
  (selectCompany)="onClick($event)"
  (adminPanelClick)="onAdminPanelClick()"
></app-company-selection-list>
